import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import 'client/styles/tax/expenseRow.scss';

const propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  header: '',
  description: '',
  className: null,
};

const ExpenseRow = (props) => {
  const { header, description, className } = props;
  return (
    <div className={cx('expense-row table v-middle', className)}>
      <div className="td">
        <strong>{header}</strong>
        <div>{description}</div>
      </div>
    </div>
  );
};

ExpenseRow.propTypes = propTypes;
ExpenseRow.defaultProps = defaultProps;

export default ExpenseRow;
